import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { forgetPasswordSchema } from "../../utils/schema";
import { forgotPasswordCall, updateForgetData } from "../slice";
import { toast } from "react-toastify";
import Loader from "../../component/Loader";
import BackButton from "./../../component/BackButton";
import { subdomainSelector } from "../subdomainSlice";

function ForgetPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const subdomain = useSelector(subdomainSelector);

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    control,
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    resolver: yupResolver(forgetPasswordSchema),
    shouldFocusError: true,
  });

  const onSubmit = (data) => {
    setLoading(true);
    dispatch(
      forgotPasswordCall({
        email: data?.email?.trim()?.toLowerCase(),
        user_type: "user",
        url_id: subdomain
      })
    ).then(async (res) => {
      setLoading(false);
      if (res?.payload?.code === 1) {
        await localStorage.setItem(
          "forgetdata",
          JSON.stringify(res?.payload?.data)
        );
        await localStorage.setItem("email", data?.email?.trim()?.toLowerCase());
        navigate("/otp", { replace: true });
        dispatch(updateForgetData(res?.payload?.data?.userId));

        toast.success(res?.payload?.message);
      } else {
        toast.error(res?.payload?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
        <div className="col-sm-12 col-md-5 col-lg-5 d-flex justify-content-center order-2 order-md-1"
            style={{
              backgroundColor: 'white',
              minHeight: '100vh'
            }}
          >
            <div style={{ 
              width: '100%', 
              maxWidth: 500, 
              textAlign: 'center',
              padding: '0px 20px'
            }}>
              {/* Logo and Title Section */}
              <div style={{ 
                textAlign: 'left', 
                marginTop: 20, 
                marginBottom: 15, 
                display: 'flex',
                alignItems: 'flex-start',
                gap: '20px'
              }}>
                <img
                  src={localStorage.getItem('company_logo') || '/assets/img/banner_logo.png'}
                  alt="logo"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: 'cover',
                    borderRadius: '50%',
                  }}
                />
                <div>
                  <h2 style={{ 
                    fontWeight: 700, 
                    fontSize: '20px', 
                    color: '#23235b', 
                    margin: '25px 0 8px 0',
                    lineHeight: '1.0'
                  }}>
                    Recover Your Club Account
                  </h2>
                  <p style={{ 
                    fontSize: '16px', 
                    color: '#666', 
                    margin: 0,
                    fontWeight: 400
                  }}>
                    Powered by BookInClass
                  </p>
                </div>
              </div>

              {/* Help Section */}
              <div style={{
                backgroundColor: '#b3e6f9',
                color: 'white',
                padding: '12px 20px',
                marginBottom: '20px',
                fontWeight: 700,
                fontSize: '18px',
                textAlign: 'left', 
                color: '#23235b'
              }}>
                Help
              </div>

              {/* Instructions */}
              <div style={{ 
                textAlign: 'left',
                fontSize: '15px', 
                color: '#333', 
                lineHeight: 1.6,
                marginBottom: '15px'
              }}>
                <div style={{ fontWeight: 600, fontSize: '18px', marginBottom: '16px' }}>
                 Forgot Your Password?
                </div>
                <p style={{ marginBottom: '16px' }}>
                No problem — we’re here to help!
                </p>
                <p style={{ marginBottom: '16px' }}>
                Enter your registered email address on the right. We’ll send you a One-Time Password (OTP) to that email.
                </p>
                <p style={{ marginBottom: '16px' }}>
                Once you receive the OTP, you’ll be able to verify your identity and reset your password securely.
                </p>
                <p style={{ marginBottom: '16px' }}>
                Need more help? Reach out to our support team anytime.
                </p>
            </div>
            </div>
          </div>
        <div className="col-sm-12 col-md-7 col-lg-7 order-1 order-md-2" style={{backgroundColor: '#b3e6f9'}}>
            <BackButton />
            <div className="form-style mt-5">
              <form className="row" onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group col-sm-12 col-md-12 text-center mb-5">
                  <div className="">
                    <img
                      src="assets/img/forgot-password.png"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
                <div className="form-group col-sm-12 col-md-12 text-center mb-4">
                  <h2 className="mdl-ttl">forgot password</h2>
                  <p>
                    In order to retrieve your password, please enter registered
                    email address
                  </p>
                </div>
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="form-group col-sm-12 col-md-12 col-lg-12 mb-4">
                  <label className="fw-bold">Email ID</label>

                  <div className="input-container">
                    <input
                      type="text"
                      className="form-control ps-4"
                      placeholder="Email Address"
                      name="email"
                      {...register("email")}
                    />
                    <img
                      src="assets/img/email.png"
                      className="input-img"
                      alt=""
                    />
                  </div>
                  {errors?.email && (
                    <div className="text-red">{errors?.email?.message}</div>
                  )}
                </div>
                <div className="form-group col-sm-12 col-md-12 text-center">
                  <button type="submit" className="btn btn-submit" style={{ width: "100%" }}>
                    {loading ? <Loader /> : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ForgetPassword;
